/** Level 1 values every player starts with. */
export const INITIAL_PLAYER_STATS = {
    maxHealth: 100,
    maxEnergy: 100,
    baseDamage: 10,
};
/** Added to the level 1 values once per level gained. */
export const LEVEL_UP_GROWTH = {
    maxHealth: 20,
    maxEnergy: 10,
    baseDamage: 3,
};
export const PLAYER_MOVEMENT = {
    /** Units per second on the ground plane. */
    speed: 6,
    jumpVelocity: 7.5,
    gravity: -20,
    /** Energy regained per second while alive. */
    energyRegenPerSecond: 4,
};
export const PLAYER_RESPAWN_DELAY_MS = 5000;
/**
 * How long the server keeps a player in the attacking or hurt animation state
 * before it falls back to idle or moving.
 */
export const COMBAT_ANIMATION_DURATION_MS = 400;
//# sourceMappingURL=stats.js.map